export default __webpack_public_path__ + "static/media/img-fremder-purple.eb8d879f.jpg";